"use client";
import dynamic from "next/dynamic";
import type { ModuleComponent } from "./ModuleCreator";
import type { ModuleComponents } from "./ModuleMapTypes";

const moduleHero = dynamic(() => import("@components/cms/hero/Hero").then((mod) => mod.Hero));
const moduleText = dynamic(() => import("@components/cms/text/Text").then((mod) => mod.Text));
const moduleImage = dynamic(() => import("@components/cms/image/Image").then((mod) => mod.Image));
const moduleVideo = dynamic(() => import("@components/cms/video/Video").then((mod) => mod.Video), {
    ssr: false,
});
const moduleSpacer = dynamic(() =>
    import("@components/cms/spacer/Spacer").then((mod) => mod.Spacer)
);
const moduleHotspot = dynamic(
    () => import("@components/cms/hotspot/Hotspot").then((mod) => mod.Hotspot),
    // Setting ssr to false will break SSR for some reason
    { ssr: true }
);
const moduleHeadline = dynamic(() =>
    import("@components/cms/headline/Headline").then((mod) => mod.Headline)
);
const moduleAccordion = dynamic(() =>
    import("@components/cms/accordion/Accordion").then((mod) => mod.Accordion)
);
const moduleHeroSlider = dynamic(() =>
    import("@components/cms/hero-slider/HeroSlider").then((mod) => mod.HeroSlider)
);
const moduleCardGeneric = dynamic(() =>
    import("@components/cms/card-generic/CardGeneric").then((mod) => mod.CardGeneric)
);
const moduleStoryTileGrid = dynamic(() =>
    import("@components/cms/story-tile-grid/StoryTileGrid").then((mod) => mod.StoryTileGrid)
);
const moduleCardLinkCollection = dynamic(() =>
    import("@components/cms/card-link-collection/CardLinkCollection").then(
        (mod) => mod.CardLinkCollection
    )
);
const moduleCustomProductCarousel = dynamic(() =>
    import("@components/cms/custom-product-carousel/CustomProductCarousel").then(
        (mod) => mod.CustomProductCarousel
    )
);

const moduleBazaarvoiceGallery = dynamic(() =>
    import("@components/cms/bazaarvoice-gallery-container/BazaarvoiceGalleryContainer").then(
        (mod) => mod.BazaarvoiceGalleryContainer
    )
);

const partStoryTile = dynamic(() =>
    import("@components/cms/split-campaign-banner/SplitCampaignBanner").then(
        (mod) => mod.SplitCampaignBanner
    )
);

const modulesMap: Partial<ModuleComponents> = {
    moduleHero, // Safe
    moduleText, // Safe
    moduleImage, // Safe
    moduleVideo, // Safe
    moduleSpacer, // Safe
    moduleHotspot, // Breaks SSR if {ssr:false}
    moduleHeadline, // Safe
    moduleAccordion, // Safe
    moduleHeroSlider, // Safe
    moduleCardGeneric, // Safe
    moduleStoryTileGrid, // Safe
    moduleCardLinkCollection, // Safe
    moduleCustomProductCarousel, // Safe
    moduleBazaarvoiceGallery, //Safe
    partStoryTile, // Safe
};

export const getModuleComponent = (type: string): ModuleComponent | undefined =>
    modulesMap[type as keyof ModuleComponents] as ModuleComponent | undefined;
